export default "__VITE_ASSET__Bea_Oii8__"